module.exports = __webpack_public_path__ + "img/stone_wash.d23dc29a.jpg";